import React, { Component} from "react";
import Loadable from 'react-loadable';



import { instanceOf } from 'prop-types';

import isEqual from 'lodash/isEqual'

import union from 'lodash/union'
import moment from 'moment'

import { BrowserRouter, Route, Redirect} from "react-router-dom";
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import { connect } from "react-redux";
import * as actions from "./actions";

import DialogSignIn from "./components/signIn/DialogSignIn";

import DisplayedMessage from "./components/main/DisplayedMessage"
import Success from "./components/payments/Success"
import Error from "./components/payments/Error"

import NavTopFixedBar from './components/navs/NavTopFixedBar'
import MobileNav from './components/navs/MobileNav'
import NavBar from './components/navs/NavBar'


import UserAgreementDialog from './components/reusableComponents/UserAgreementDialog'
import Preloader from './components/reusableComponents/Preloader'

import Hidden from '@material-ui/core/Hidden';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import { withCookies, Cookies } from 'react-cookie';

import {userDeviceCheck} from './userDeviceCheck'
//import Main from './components/main/Main'

const Main = Loadable({
  loader: () => import('./components/main/Main'),
  loading: Preloader,
});

const OrderPage = Loadable({
  loader: () => import('./components/main/OrderPage'),
  loading: Preloader,
});

const ControlPanel = Loadable({
  loader: () => import('./components/controlPanel/ControlPanel'),
  loading: Preloader,
});

const BetVideosPage = Loadable({
  loader: () => import('./components/main/BetVideosPage'),
  loading: Preloader,
});

const BetAdvices = Loadable({
  loader: () => import('./components/main/BetAdvices'),
  loading: Preloader,
});

const UserPanel = Loadable({
  loader: () => import('./components/userPanel/UserPanel'),
  loading: Preloader,
});

const UserDeviceLimitation = Loadable({
  loader: () => import('./components/main/UserDeviceLimitation'),
  loading: Preloader,
});

const theme = createMuiTheme({
  root:{

  },
  palette: {
    primary: { main: "#111111", gold: "#B38728", light: "#606060" , dark:"#111111", lightdark: "#474543"},
    secondary: { main: '#606060', },
    background: {
      gold: "linear-gradient(125deg, #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
      dark: "#111111",
      lightdark: "#474543",
      white:"rgba(255,255,255,0.90)",
      warning: "red",
      success: "green",
    },
    text:{
      primary: "#111111",
      secondary:"#474543"
    }
  },
  typography:{
    fontFamily: '"Kanit", serif',
    "fontSize": 15,
    "fontWeightLight": 300,
    "fontWeightRegular": 400,
    "fontWeightMedium": 500
  },
  overrides:{

  }
})

class App extends Component {
  state = {}

  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,

  };



  componentDidMount(){

    this.props.fetchAllProductsOnce()
    this.props.fetchUser()
    this.props.fetchPackageStatisticOnce()
    this.props.fetchFreeBetPageOnce()
    this.props.getAuthRedirectResponse()

    if(this.props.cookies.get("cookie_consent") === "true"){

      ReactGA.initialize('UA-128352218-1');
      ReactGA.pageview(window.location.pathname + window.location.search);


      const advancedMatching = { }
      const options = {
          autoConfig: true, 	// set pixel's autoConfig
          debug: false, 		// enable logs
      };
      ReactPixel.init('2186843081590155', advancedMatching, options);

      ReactPixel.pageView();
    }
    //ReactPixel.pageView();
  }

  componentDidUpdate(prevProps){

    if(!isEqual(prevProps.auth, this.props.auth) || !isEqual(prevProps.productsData, this.props.productsData)){

       if(this.props.auth && !this.props.auth.admin && !this.props.auth.mod && this.props.productsData !== "loading" && this.props.premiumBetsData === "loading"){
         let userActivePackages = []

         if(this.props.auth.access){
           Object.entries(this.props.auth.access.packages).forEach(([packageKey, packageObj])=>{
             let activeUntil = moment.unix(packageObj.timestamp/1000 + packageObj.duration/1000)

             if(activeUntil.isSameOrAfter(moment(), "day")){

               if(this.props.productsData[packageKey] && !this.props.productsData[packageKey].isFrozen)userActivePackages.push(packageKey)
             }
           })
         }


         let freePackages = Object.entries(this.props.productsData).filter(([productKey, product]) => product.settings.isFree  )
         freePackages = freePackages.map(([productKey, product]) => {return productKey})

         let allActivePackages = union(freePackages, userActivePackages)
         if(allActivePackages.length === 0 )this.props.setPremiumBetsToEmpty()

         allActivePackages.forEach((packageId)=>{
           console.log(packageId)
           this.props.fetchPremiumBetsByPackageIdStream(packageId)
         })


       }

       if(this.props.auth && this.props.auth.admin && this.props.premiumBetsData === "loading")this.props.fetchPremiumBetsStream()
       if(this.props.auth && this.props.auth.mod && this.props.premiumBetsData === "loading"){
         Object.entries(this.props.auth.mod).forEach(([packageKey, access])=>{
           if(access)this.props.fetchPremiumBetsByPackageIdStream(packageKey)
         })
       }
    }


  }
  /*
  <Route exact path="/" render={()=>(
      this.props.auth ? (<Redirect to="/mojestave"/>):(<Main />))}
  />
  <Route exact path="/" render={()=>(<Main />)}/>
  */

  render() {
    //console.log("app")
    return (
      <BrowserRouter>
        <MuiThemeProvider theme={theme}>
          <div >

            <div style={{position:"fixed", top:0, display:"flex", flexDirection:"row", justifyContent:"center" , width: "100%",height: "100vh"}}>
              <span style={{position:"absolute", height:"100vh", width:"100%", background: "rgba(255,255,255,0.5)"}}></span>
              <div style={{display:"flex", flexDirection:"column", justifyContent:"center", height:"100%"}}>
                <img  src="https://i.imgur.com/TujEG00.png" alt="wolf" style={{display: "block"}}/>
              </div>
            </div>
            <Hidden mdUp>
              <MobileNav />
            </Hidden>

            <NavTopFixedBar />

            <UserAgreementDialog />
            <DisplayedMessage />
            <Route exact path="/narocilo/" component={OrderPage} />
            <Route exact path="/narocilo/:productId" component={OrderPage} />
            <Route exact path="/narocilo/:productId/:paymentType/:duration" component={OrderPage} />



            <Route exact path="/" render={()=>(
                this.props.auth ?
                  (this.props.auth.admin || this.props.auth.mod) ?
                  (<Redirect to="/controlpanel"/>) :
                    this.props.premiumBetsData === "loading" ?
                      (<Preloader/>):
                      isEqual(this.props.premiumBetsData,{}) ?
                      (<Redirect to="/narocilo"/>):
                      (<Redirect to="/mojestave"/>):
                (<Main />))}
            />


            <Route path="/stavneosnove" render={()=>{
              return(
                <div>
                  <NavBar homeNav/>
                  <Hidden mdUp>
                    <MobileNav />
                  </Hidden>
                  <BetAdvices />
                </div>
              )
            }}
            />
            <Route path="/mojestave" render={(props)=>{
                  if(this.props.auth){

                    if(userDeviceCheck(this.props.auth, this.props.cookies, this.props.updateUserDevices, this.props.showWebpageDisplayedInfo))return <UserPanel {...props}/>
                    else return <Redirect to="/omejitevnaprav"/>
                  }else return <Redirect to="/"/>
                }
              }
            />


            <Route path="/controlpanel" render={(props)=>(
               this.props.auth && (this.props.auth.admin || this.props.auth.mod) ? <ControlPanel {...props}/> : <Redirect to="/"/>)}
            />


            <Route path="/omejitevnaprav" render={()=><UserDeviceLimitation cookies={this.props.cookies} />} />
            <Route path="/payment/success" component={Success} />
            <Route path="/payment/error" component={Error} />
            <Route path="*" component={null} />

            <Route path="/pogojiuporabe" render={()=>{
              this.props.showUserAgreementDialog(true)
              return(
                <Main />
              )
            }}/>
            <DialogSignIn />
          </div>
        </MuiThemeProvider>
      </BrowserRouter>
    );
  }


}


const mapStateToProps = ({  auth, productsData, premiumBetsData }) => {
  return {
    auth,
    productsData,
    premiumBetsData
  };
};


export default connect(mapStateToProps, actions)(withCookies(App));



// WEBPACK FOOTER //
// ./src/App.js